import { useTranslation } from "react-i18next";
import FadeInSection from "../animations/FadeInSection";
import VoucherSpread from "./vouchers/VoucherSpread";
import type { VoucherType } from "@/types/home-type";
import VoucherCardHome from "./vouchers/VoucherCard";

export default function VoucherSection({
    vouchers,
}: {
    vouchers: VoucherType[];
}) {
    const { t, i18n } = useTranslation();
    const locale = i18n.language as "id" | "en" | "my";

    if (!vouchers || vouchers.length === 0) return null;

    return (
        <FadeInSection>
            <section className="relative py-2 bg-cream dark:bg-transparent transition-colors duration-300">
                <div className="absolute inset-0 opacity-[0.03] overflow-hidden pointer-events-none">
                    {/* dekorasi */}
                    <svg
                        viewBox="0 0 100 100"
                        className="w-full text-dark dark:text-white"
                        fill="currentColor">
                        <circle cx="10" cy="10" r="2" />
                    </svg>
                </div>

                <div className="max-w-6xl mx-auto px-6 relative z-10">
                    <div className="text-center mb-4">
                        <div className="flex items-center justify-center gap-3 text-xs md:text-sm font-semibold tracking-[0.15em] uppercase text-gold mb-2">
                            <div className="w-12 h-px bg-gold/30" />
                            {t("home.voucher.badge")}
                            <div className="w-12 h-px bg-gold/30" />
                        </div>
                        <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-dark dark:text-white leading-tight">
                            {t("home.voucher.title_1")}{" "}
                            <br className="md:hidden" />
                            <em className="italic text-gold px-1">
                                {t("home.voucher.title_span")}
                            </em>{" "}
                            {t("home.voucher.title_2")}
                        </h2>
                        <p className="text-dark/70 dark:text-white/50 mt-4 text-base md:text-lg">
                            {t("home.voucher.desc")}
                        </p>
                    </div>
                    <div className="w-full flex justify-center">
                        <div className="max-w-fit flex items-center gap-2 mb-6 border border-gold/30 bg-gold/10 text-gold dark:text-gold-light px-5 py-2 rounded-full text-sm">
                            <span className="relative flex h-3 w-3">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-3 w-3 bg-gold"></span>
                            </span>
                            {t("home.voucher.badge_2")}
                        </div>
                    </div>

                    <div className="grid lg:grid-cols-[1fr_1.1fr] gap-12 items-center">
                        <VoucherSpread vouchers={vouchers} locale={locale} />
                        <div className="hidden md:block space-y-4">
                            <VoucherCardHome
                                vouchers={vouchers}
                                locale={locale}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </FadeInSection>
    );
}
